(function () {
  if (window.__mrblueWaveReady) return;
  window.__mrblueWaveReady = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCanvas(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;

    var mouse = { x: -9999, y: -9999 };
    var lines = 36;
    var points = 80;
    var animationId = 0;
    var time = 0;

    function resize() {
      var rect = canvas.getBoundingClientRect();
      var dpr = window.devicePixelRatio || 1;
      canvas.width = Math.floor(rect.width * dpr);
      canvas.height = Math.floor(rect.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function onMove(event) {
      var rect = canvas.getBoundingClientRect();
      mouse.x = event.clientX - rect.left;
      mouse.y = event.clientY - rect.top;
    }

    function onLeave() {
      mouse.x = -9999;
      mouse.y = -9999;
    }

    function draw() {
      var width = canvas.clientWidth;
      var height = canvas.clientHeight;
      ctx.clearRect(0, 0, width, height);
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.22)';
      ctx.lineWidth = 1;

      for (var i = 0; i <= lines; i++) {
        var baseX = (width / lines) * i;
        ctx.beginPath();

        for (var j = 0; j <= points; j++) {
          var yNorm = (j / points) * height;
          var wave =
            Math.sin(yNorm * 0.018 + time * 0.015 + i * 0.35) * 14 +
            Math.sin(yNorm * 0.008 + time * 0.01) * 8;

          var dx = baseX - mouse.x;
          var dy = yNorm - mouse.y;
          var dist = Math.sqrt(dx * dx + dy * dy);
          var pull = dist < 140 ? ((140 - dist) / 140) * 28 : 0;
          var x = baseX + wave + (dx / (dist || 1)) * pull;

          if (j === 0) ctx.moveTo(x, yNorm);
          else ctx.lineTo(x, yNorm);
        }

        ctx.stroke();
      }

      time += 1;
      if (!reduceMotion) {
        animationId = window.requestAnimationFrame(draw);
      }
    }

    resize();
    if (!reduceMotion) {
      draw();
    } else {
      time = 0;
      draw();
    }

    window.addEventListener('resize', resize);
    canvas.closest('.mrblue-fx-hero')?.addEventListener('mousemove', onMove);
    canvas.closest('.mrblue-fx-hero')?.addEventListener('mouseleave', onLeave);

    return function cleanup() {
      window.cancelAnimationFrame(animationId);
      window.removeEventListener('resize', resize);
    };
  }

  function init() {
    document.querySelectorAll('.mrblue-wave-canvas').forEach(function (canvas) {
      initCanvas(canvas);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
